import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import EditorCredit from '../../components/EditorCredit';

export default function CGU() {
  return (
    <div className="min-h-screen bg-white" data-testid="cgu-page">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 py-12 lg:py-20">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#475569] hover:text-[#0F172A] mb-8">
          <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
        </Link>

        <h1 className="font-display text-4xl lg:text-5xl font-black tracking-tight text-[#0F172A] mb-3">Conditions Générales d'Utilisation</h1>
        <p className="text-sm text-[#475569] mb-10">Dernière mise à jour : juin 2026</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">1. Objet</h2>
            <p className="text-[#0F172A]">
              Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation du service
              <strong> AssoPerf</strong>, plateforme SaaS dédiée à la gestion des associations (membres, événements,
              billetterie, paiements). L'accès au service implique l'acceptation pleine et entière de ces CGU.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">2. Description du service</h2>
            <p className="text-[#0F172A]">AssoPerf permet aux associations :</p>
            <ul className="list-disc list-inside text-[#0F172A] mt-2 space-y-1 pl-2">
              <li>De gérer leurs membres (adhésions, cotisations, validation, relances)</li>
              <li>De créer et gérer des événements avec billetterie en ligne</li>
              <li>De personnaliser leur espace (logo, couleurs, formules d'adhésion)</li>
              <li>D'encaisser les paiements via Stripe Connect</li>
              <li>De communiquer avec leurs membres par email automatisé</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">3. Inscription et compte</h2>
            <p className="text-[#0F172A]">
              L'inscription est gratuite et nécessite la fourniture d'informations exactes et à jour. Chaque
              association désigne un ou plusieurs administrateurs (président, vice-président, secrétaire, trésorier)
              qui auront accès au back-office. L'utilisateur est responsable de la confidentialité de ses
              identifiants.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">4. Abonnement et facturation</h2>
            <p className="text-[#0F172A]">
              AssoPerf propose plusieurs formules d'abonnement (Starter, Pro, Network) facturées mensuellement
              ou annuellement. Le paiement s'effectue par carte bancaire via Stripe. L'abonnement est résiliable
              à tout moment, la résiliation prend effet à la fin de la période de facturation en cours.
            </p>
            <p className="text-[#0F172A] mt-3">
              Les frais Stripe (1,4% + 0,25€ par transaction en France) sont facturés directement par Stripe
              aux associations utilisant la billetterie.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">5. Obligations de l'utilisateur</h2>
            <p className="text-[#0F172A]">L'utilisateur s'engage à :</p>
            <ul className="list-disc list-inside text-[#0F172A] mt-2 space-y-1 pl-2">
              <li>Utiliser le service conformément à la loi française</li>
              <li>Ne pas tenter de contourner les mesures de sécurité</li>
              <li>Respecter les droits des autres utilisateurs et des tiers</li>
              <li>Ne pas utiliser AssoPerf à des fins illicites, frauduleuses ou diffamatoires</li>
              <li>Respecter le RGPD pour les données de ses membres</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">6. Propriété des données</h2>
            <p className="text-[#0F172A]">
              Les données saisies par les associations (membres, événements, paiements) leur appartiennent et
              restent sous leur contrôle. AssoPerf agit en tant que sous-traitant au sens du RGPD. À tout moment,
              les associations peuvent exporter leurs données ou demander leur suppression complète.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">7. Responsabilité</h2>
            <p className="text-[#0F172A]">
              AssoPerf met tout en œuvre pour assurer la disponibilité du service mais ne peut être tenu responsable
              en cas d'interruption temporaire pour maintenance, mise à jour, ou en cas de force majeure. La
              responsabilité de l'éditeur est limitée au montant payé par l'utilisateur sur les 12 derniers mois.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">8. Résiliation</h2>
            <p className="text-[#0F172A]">
              L'éditeur se réserve le droit de suspendre ou résilier l'accès au service en cas de non-respect
              des présentes CGU, avec ou sans préavis selon la gravité du manquement.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">9. Modification des CGU</h2>
            <p className="text-[#0F172A]">
              L'éditeur peut modifier les CGU à tout moment. Les utilisateurs seront informés par email au moins
              30 jours avant l'entrée en vigueur des modifications.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">10. Droit applicable</h2>
            <p className="text-[#0F172A]">
              Les présentes CGU sont régies par le droit français. Tout litige sera soumis aux tribunaux
              compétents de Lyon.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#E2E8F0] flex flex-wrap gap-4 text-xs text-[#475569]">
          <Link to="/mentions-legales" className="hover:text-[#0F172A]">Mentions légales</Link>
          <Link to="/confidentialite" className="hover:text-[#0F172A]">Confidentialité</Link>
          <Link to="/" className="hover:text-[#0F172A]">Accueil</Link>
        </div>
      </div>
      <EditorCredit variant="light" />
    </div>
  );
}
